"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { Button } from "@/components/ui/button";

type OrderCardProps = {
  onCompleteOrder?: () => void;
  topSlot?: React.ReactNode;
  buttonLabel?: string;
} & React.ComponentProps<"div">;

export const OrderCard = ({
  className,
  topSlot,
  onCompleteOrder,
  buttonLabel = "Go to homepage",
  children,
}: OrderCardProps) => {
  return (
    <div
      className={cn(
        "rounded-[18px] flex bg-white shadow-[0_3.6px_45.04px_0p_rgba(0,0,0,0.1)] py-6 px-4 border border-border-default md:px-6",
        className
      )}
    >
      <div className="grid grid-cols-1 gap-6 flex-auto min-w-0">
        {topSlot}
        {children}
        <div className="flex items-end justify-center">
          <Button
            onClick={onCompleteOrder}
            type="button"
            variant="primary"
            className="w-full h-12"
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(OrderCard);
